<template lang="pug">
  .WtSvgIcon(v-html="require(`!!html-loader!@@@/${icon}.svg`)" :alt="icon" v-once)
</template>

<script>
export default {
  name: "WtSvgIcon",

  props: {
    icon: {
      default: "",
      type: String
    },
    width: {
      default: "32px",
      type: String
    },
    height: {
      default: "32px",
      type: String
    },
    opacity: {
      default: "1",
      type: String
    }
  },
  mounted() {
    this.$el.querySelector("svg").setAttribute("height", this.height);
    this.$el.querySelector("svg").setAttribute("width", this.width);
    this.$el.querySelector("svg").setAttribute("opacity", this.opacity);
  }
};
</script>

<style lang="sass" scoped>
.WtSvgIcon
  svg
    display: block
</style>
